import { render, staticRenderFns } from "./SidePanelPreview.vue?vue&type=template&id=66360fa8&scoped=true&"
import script from "./SidePanelPreview.vue?vue&type=script&lang=js&"
export * from "./SidePanelPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66360fa8",
  null
  
)

export default component.exports